import HoverTooltip from '@deltek/specification-client/core/Feedbacks/HoverTooltip'
import { useProductListingStyle } from 'bpm/pages/ProductsPage/ProductListingsPage/ProductLisitngsPage.styles'
import React from 'react'
import { Link } from 'react-router-dom'
import { TVData } from '../../ProductCardManagementPage.types'

const ProductNameCell = ({ row }: TVData) => {
    const classes = useProductListingStyle({})
    const listingId = row.original?.listingId
    const text = !!row.original
        ? row.original.productName
            ? row.original.productName
            : 'No product name'
        : ''

    const productDetailPath = !!listingId
        ? `/bpm/products/product/listing/${listingId}`
        : `/bpm/products/all`

    return (
        <HoverTooltip text={text}>
            <Link
                to={{
                    pathname: productDetailPath,
                    search: '?showBackButton=false',
                }}
                className={classes.productNameText}
                target="_blank"
                style={{
                    textDecoration: 'none',
                }}
            >
                {text}
            </Link>
        </HoverTooltip>
    )
}

export default ProductNameCell
